export const CONTRACT_UPDATE_ROUTE_PREFIX = "/admin/contract-updates";

export const CONTRACT_UPDATE_ROUTE_PATHS = {
  list: { path: "*", to: CONTRACT_UPDATE_ROUTE_PREFIX }
};
